export default __webpack_public_path__ + "static/media/AbsoluteHero.219016f4.mp3";